import type {
  Category,
  CategoryStatus,
  ComponentMode,
  FileOwnerType,
} from 'types';

interface State extends Category {
  mode: ComponentMode;
  step: 1 | 2;
  ownerType: FileOwnerType;
  defaultStatus: CategoryStatus;
  defaultTitle: string;
}
const initialState: Partial<State> = {};

type Action =
  | {
      type: 'UPDATE_CATEGORY_ICON';
      payload: Pick<typeof initialState, 'iconId'>;
    }
  | {
      type: 'UPDATE_CATEGORY_TITLE';
      payload: Pick<typeof initialState, 'title'>;
    }
  | {
      type: 'UPDATE_CATEGORY_PARENT';
      payload: Pick<typeof initialState, 'parent'>;
    }
  | {
      type: 'UPDATE_CATEGORY_RELATED_ATTRIBUTE';
      payload: Pick<typeof initialState, 'relatedAttribute'>;
    }
  | {
      type: 'UPDATE_CATEGORY_SUB_SLUG';
      payload: Pick<typeof initialState, 'subSlug'>;
    }
  | {
      type: 'UPDATE_CATEGORY_DESCRIPTION';
      payload: Pick<typeof initialState, 'description'>;
    }
  | {
      type: 'UPDATE_CATEGORY_SEO';
      payload: Pick<typeof initialState, 'seo'>;
    }
  | {
      type: 'UPDATE_CATEGORY_CATALOG_BRAND';
      payload: Pick<typeof initialState, 'catalogBrand'>;
    }
  | {
      type: 'UPDATE_CATEGORY_TAGS';
      payload: Pick<typeof initialState, 'tags'>;
    }
  | {
      type: 'UPDATE_CATEGORY_STEP';
      payload: Pick<typeof initialState, 'step'>;
    }
  | undefined;
const initialAction: Action = undefined;

export { initialAction, initialState };
